import React from 'react'

const SvgComponent = props => (
  <svg width={66} height={66} {...props}>
    <defs>
      <linearGradient
        x1="7.569%"
        y1="110.903%"
        x2="78.899%"
        y2="7.982%"
        id="swift__prefix__a"
      >
        <stop stopColor="#FAC9E3" stopOpacity={0.4} offset="0%" />
        <stop stopColor="#E3486A" offset="100%" />
      </linearGradient>
      <linearGradient
        x1="-12.039%"
        y1="1.214%"
        x2="155.653%"
        y2="90.79%"
        id="swift__prefix__b"
      >
        <stop stopColor="#FBA4B5" offset="0%" />
        <stop stopColor="#E3486A" offset="100%" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd">
      <circle
        fill="url(#swift__prefix__a)"
        opacity={0.166}
        cx={33}
        cy={33}
        r={33}
      />
      <path
        d="M42 21a20.904 20.904 0 0 1-4.991 13.592C33.157 39.124 27.414 42 21 42 9.402 42 0 32.598 0 21A20.91 20.91 0 0 1 4.817 7.617l.094-.114C8.763 2.916 14.54 0 21 0c11.598 0 21 9.402 21 21z"
        fill="url(#swift__prefix__b)"
        transform="translate(12 12)"
      />
      <path
        d="M49.942 46.503c-.223.294-.453.582-.691.864-.752-1.216-1.931-2.418-3.7-2.628-3.768-.45-5.205 2.096-9.17 2.596-15.465 1.996-23.573-11.333-23.573-11.333 6.548 5.045 15.522 6.209 21.304 2.49l-.062-.043c-7.519-5.34-15.419-15.94-17.25-18.469a52.06 52.06 0 0 1-.395-.551c.162.146.325.291.489.436 6.92 6.138 14.678 11.045 14.678 11.045-5.95-5.993-10.583-13.363-10.656-13.477 7.931 8.735 18.24 14.975 18.24 14.975 3.3-10.07-3.482-17.887-3.568-17.985.095.052 8.047 4.557 10.954 13.293 1.375 4.13 1.019 7.72.256 10.364 2.637 2.936 3.291 6.326 3.144 8.423z"
        fill="#F2F2F2"
      />
    </g>
  </svg>
)

export default SvgComponent
